import Datetime from './datetime'

export const HOUR_MINUTES = 60
export const QUARTER_MINUTES = 15

function getDayStepStarts(instant: ISODateTime, stepMinutes: number): ISODateTime[] {
  const dayStart = Datetime.getStartOfDay(instant)
  const nextDayStart = Datetime.getDayAfterDate(dayStart).startTime

  return Datetime.getDateTimesBetween(dayStart, Datetime.addMinutes(nextDayStart, -stepMinutes), stepMinutes)
}

export function getDayHourStarts(instant: ISODateTime): ISODateTime[] {
  return getDayStepStarts(instant, HOUR_MINUTES)
}

export function getDayQuarterStarts(instant: ISODateTime): ISODateTime[] {
  return getDayStepStarts(instant, QUARTER_MINUTES)
}

export function getDayTimeStepLabels(starts: readonly ISODateTime[], stepMinutes: number): string[] {
  const offsetsMinutes = starts.map((start) => Datetime.getLocalUtcOffsetMinutes(start))
  const ranges = starts.map((start, index) => {
    const end = Datetime.addMinutes(start, stepMinutes)
    return `${Datetime.toHourAtUtcOffset(start, offsetsMinutes[index])} - ${Datetime.toHourAtUtcOffset(end, offsetsMinutes[index])}`
  })
  const occurrences = new Map<string, number>()
  for (const range of ranges) {
    occurrences.set(range, (occurrences.get(range) ?? 0) + 1)
  }

  return ranges.map((range, index) => {
    const isRepeated = (occurrences.get(range) ?? 0) > 1
    const bordersOffsetChange = [offsetsMinutes[index - 1], offsetsMinutes[index + 1]].some(
      (neighbourOffset) => neighbourOffset !== undefined && neighbourOffset !== offsetsMinutes[index]
    )
    return isRepeated || bordersOffsetChange ? `${range} (${Datetime.getLocalUtcOffset(starts[index])})` : range
  })
}

export function getHourStepLabel(start: ISODateTime): string {
  const starts = getDayHourStarts(start)
  const hourIndex = Math.floor(Datetime.getNrOfMinutesBetween(starts[0], start) / HOUR_MINUTES)
  return getDayTimeStepLabels(starts, HOUR_MINUTES)[hourIndex]
}

export function getUtcHourStart(time: string | number): ISODateTime {
  const instant = new Date(time)
  instant.setUTCMinutes(0, 0, 0)
  return Datetime.toISOString(instant)
}

export function isSameInstantHour(first: ISODateTime, second: ISODateTime): boolean {
  return getUtcHourStart(first) === getUtcHourStart(second)
}
